import React from 'react';
import { Formik } from 'formik';
import { BsClock } from 'react-icons/bs';
import { useMutation } from 'react-query';
import { useFlashMessage } from '@app/components/obj.flash-message';
import { axiosClient } from '@app/configure-app';
import { FlashMessageEnum } from '@atomic';
import { ESQUEMA_CONTATO, MENSAGEM_ERRO_CONTATO, NPS_CONSENTIMENTO_CHECKBOX, PATCH_NPS_URL } from '../../nps.constants';
import { AcoesStyled, FormularioStyled, IconeSuaveStyled, RodapeStyled } from '../nps-bloco';
import { NpsBotao } from '../nps-botao';
import { NpsCabecalho } from '../nps-cabecalho';
import { NpsContato, NpsFraseConsentimento } from '../nps-contato';
import { NpsTelaFolha } from '../nps-tela';
import { DicaStyled } from './nps-repescagem.component.style';
// Tela 2b: detrator que enviou sem contato. Atualiza o mesmo registro do NPS com o contato (D10).
export var NpsRepescagem = function (_a) {
    var npsId = _a.npsId, logo = _a.logo, empresa = _a.empresa, unidade = _a.unidade, onContatoEnviado = _a.onContatoEnviado, onPreferirNaoInformar = _a.onPreferirNaoInformar;
    var showFlashMessage = useFlashMessage()[0];
    var _b = React.useState(true), consentimento = _b[0], setConsentimento = _b[1];
    var enviandoRef = React.useRef(false);
    var _c = useMutation(function (contato) {
        return axiosClient.patch(PATCH_NPS_URL + "/" + npsId + "/contato", {
            clienteNome: contato.nome,
            clienteEmail: contato.email,
            clienteTelefone: contato.telefone,
            lgpb: NPS_CONSENTIMENTO_CHECKBOX ? consentimento : true,
        });
    }, {
        onSuccess: function (_resposta, contato) { return onContatoEnviado(contato.nome); },
        onError: function (erro) {
            console.error(erro);
            showFlashMessage(FlashMessageEnum.alert, MENSAGEM_ERRO_CONTATO);
        },
        onSettled: function () {
            enviandoRef.current = false;
        },
    }), enviarContato = _c.mutate, isLoading = _c.isLoading;
    var handleSubmit = function (contato) {
        if (enviandoRef.current)
            return;
        enviandoRef.current = true;
        enviarContato(contato);
    };
    return (React.createElement(NpsTelaFolha, { topo: React.createElement(NpsCabecalho, { logo: logo, empresa: empresa, unidade: unidade, titulo: "Queremos resolver isso com voc\u00EA", subtitulo: "Sentimos muito que hoje n\u00E3o foi como deveria. Deixe seu contato e o respons\u00E1vel pela unidade fala com voc\u00EA pessoalmente." }) },
        React.createElement(Formik, { initialValues: { nome: '', telefone: '', email: '' }, validationSchema: ESQUEMA_CONTATO, validateOnMount: true, onSubmit: handleSubmit }, function (_a) {
            var isValid = _a.isValid;
            return (React.createElement(FormularioStyled, null,
                React.createElement(NpsContato, { consentimento: consentimento, onConsentimento: setConsentimento }),
                React.createElement(DicaStyled, null,
                    React.createElement(IconeSuaveStyled, { "$tamanho": 32, "$redondo": true, "aria-hidden": "true" },
                        React.createElement(BsClock, { size: 14 })),
                    "Retornamos pelo canal que voc\u00EA preferir."),
                React.createElement(AcoesStyled, null,
                    React.createElement(NpsBotao, { variante: "primario", type: "submit", disabled: !isValid || isLoading, loading: isLoading }, "Quero ser contatado"),
                    React.createElement(NpsBotao, { variante: "texto", disabled: isLoading, onClick: onPreferirNaoInformar }, "Prefiro n\u00E3o informar")),
                React.createElement(RodapeStyled, null, "Usamos seu contato s\u00F3 para responder a esta avalia\u00E7\u00E3o."),
                !NPS_CONSENTIMENTO_CHECKBOX && (React.createElement(RodapeStyled, null,
                    React.createElement(NpsFraseConsentimento, null)))));
        })));
};
